import zdjService from "@/services/zdj/zdjService";

const zdj = {
    namespaced: true,
    state: {
        loggedIn: false,
        registered: false,
        // loading: false,
        error: '',
        // credentials: {},
        logginIn: false,
        registering: false,
    },
    mutations: {
        setLoggedIn: (state, loggedIn) => {
            state.loggedIn = loggedIn
        },
        // setCredentials: (state, credentials) => {
        //     state.credentials = credentials
        // },
        setRegistered: (state, registered) => {
            state.registered = registered
        },

        setLogginIn: (state, logginIn) => {
            state.logginIn = logginIn
        },
        setRegistering: (state, registering) => {
            state.registering = registering
        },
        setError: (state, error) => {
            state.error = error;//[...state.error, error];
        },
        clearErrors: (state) => {
            state.error = '';
        }
    },
    actions: {
        getCredentials: (context) => {
            // context.commit('setLoading', true);
            zdjService.getCredentials().then((credentials) => {
                context.commit('setRegistered', !!(credentials && credentials.u && credentials.p));
                // context.commit('credentials', credentials)
            })
        },
        logout: ({commit}) => {
            commit('setLoggedIn', false);
            commit('setRegistered', false);
        },
        login: ({commit, state}) => {
            commit('setLoggedIn', false);
            commit('setRegistered', false);
            commit('setLogginIn', true);
            commit('clearErrors');
            zdjService.getCredentials()
                .then(async credentials => {
                        const isRegistered = !!(credentials && credentials.l && credentials.p);
                        commit('setRegistered', isRegistered);
                        if (!isRegistered) {
                            return undefined;
                        }
                        const loginResult = await zdjService.login(credentials.l, credentials.p);
                        return loginResult;
                    }
                )
                .then(x => {
                    console.log(x);
                    if (x && x.status === "ok") {
                        commit('setLoggedIn', true);
                        commit('setLogginIn', false);
                    } else {
                        commit('setLoggedIn', false);
                        commit('setLogginIn', false);
                    }
                })
                .catch(e => {
                    commit('setError', e);
                    commit('setLogginIn', false);
                })
        },
        register: ({commit, state}, nickname) => {
            commit('setLogginIn', true);
            commit('clearErrors');
            zdjService.signUp(nickname)
                .then(result => {
                    // console.log('>>>>>>>>>>>>>>> ', result);
                    if (result.status === "ok" && result.data && result.data.u && result.data.p) {
                        commit('setRegistered', true);
                        const credentials = result.data;
                        return zdjService.login(credentials.u, credentials.p)
                            .then(x => {
                                if (x && x.status === "ok") {
                                    commit('setLoggedIn', true);
                                    commit('setLogginIn', false);
                                } else {
                                    commit('setLoggedIn', false);
                                    commit('setLogginIn', false);
                                }
                            })
                            .catch(e => {
                                commit('setError', e);
                                commit('setLogginIn', false);
                            });
                    }
                    commit('setRegistered', false);
                    commit('setError', result.message || 'bad username');
                    commit('setLogginIn', false);
                    return ({error: result.message || 'bad username'})
                })
                .catch(e => {
                    console.log('>>>>>>>>>> e >>>>> ', e);
                    commit('setLogginIn', false);
                    commit('setError', e.toString());
                    return ({error: e})
                })
        },
    },
    getters: {
        get: state => {
            return state
        },
        loggedIn: (state) => {
            return state.loggedIn
        },
        registered: (state) => {
            return state.registered
        },
    }
}

export default zdj;
